var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._l((_vm.items),function(item){return _c('early-product-item',{key:item.id,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }